export default {
  listEncargos: [],
  encargo: {
    id: null,
    nome: '',
    valor: 0,
    tipoEncargo: 'FIXO',
    planoDeConta: null,
    ativo: true,
  },
}
